<div class="organizations-container">
  <section>
    <app-oganizations-selection
      *ngIf="organizations && pendingToken && redirectUri"
      [organizations]="organizations"
      [pendingToken]="pendingToken"
      [redirectUri]="redirectUri"
    />
  </section>
</div>
